<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="项目详情"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="900px"
  >
    <div class="dialog__container">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="基本信息" name="jbxx">
          <JBXX :projectId="projectId"></JBXX>
        </el-tab-pane>
        <el-tab-pane label="电梯信息" name="dtxx">
          <DTXX :projectId="projectId"></DTXX>
        </el-tab-pane>
        <el-tab-pane label="跟踪阶段" name="gzjd">
          <GZJD :projectId="projectId"></GZJD>
        </el-tab-pane>
        <el-tab-pane label="拜访记录" name="bfjl">
          <BFJL :projectId="projectId"></BFJL>
        </el-tab-pane>
        <!-- <el-tab-pane label="项目履行" name="xmlx">项目履行</el-tab-pane> -->
        <el-tab-pane label="操作记录" name="czjl">
          <CZJL :projectId="projectId"></CZJL>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>

import JBXX from './jbxx'
import DTXX from './dtxx'
import GZJD from './gzjd'
import BFJL from './bfjl'
import CZJL from './czjl'

export default {
  components: {
    JBXX,
    DTXX,
    GZJD,
    BFJL,
    CZJL
  },
  data() {
    return {
      activeName: "jbxx",
    };
  },

  props: ["projectId"],

  created() {

  },

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/xmgl/components/DetailProoject/index.vue